import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.94854 4.125L0 7.06588H20.3603L19.2353 10.4424H11.0956L10.2794 12.8169H18.5294L17.25 16.8034H5.71324L8.16177 9.61463L5.47059 7.65405L1.54412 19.875H16.2574L20.0515 18.0016L21.3088 13.7972L18.8603 11.8584L22.6544 10.0503L24 6.10737L21.3088 4.125H3.94854Z"
      fill="#11181C"
    />
  </svg>
)
